<template>
  <div class="grid grid-cols-7 gap-2">
    <template
      v-for="monthDaysRow in monthDaysMatrix"
      :key="monthDaysRow[0]?.value ?? 0"
    >
      <wui-btn
        v-for="day in monthDaysRow"
        :key="day.value"
        variant="brand"
        :size="24"
        :state="isDaySelected(day) ? 'filled' : 'tonal'"
        @click="onDayClick(day)"
      >
        {{ day.label }}
      </wui-btn>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { WuiBtn } from '@wui/common-library'
import { computed } from 'vue'

import { MonthDayItem } from '../model'

const COLS = 7
const MONTH_DAYS_COUNT = 31

const props = defineProps<{
  modelValue: number[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: number[]): void
}>()

const monthDaysMatrix = computed<MonthDayItem[][]>(() => {
  const days: MonthDayItem[] = Array.from({ length: MONTH_DAYS_COUNT }, (_, index) => {
    const value = index + 1
    return {
      value,
      label: String(value),
    }
  })

  const matrix: MonthDayItem[][] = []
  for (let i = 0; i < days.length; i += COLS) {
    matrix.push(days.slice(i, i + COLS))
  }

  return matrix
})

const isDaySelected = (day: MonthDayItem) => props.modelValue.includes(day.value)

const onDayClick = (day: MonthDayItem) => {
  const selected = [...props.modelValue]
  const dayIndex = selected.indexOf(day.value)

  if (dayIndex >= 0) {
    selected.splice(dayIndex, 1)
  } else {
    selected.push(day.value)
  }

  emit('update:modelValue', selected.sort((a, b) => a - b))
}
</script>
